module.exports = __webpack_public_path__ + "static/media/logo.b7f124e8.png";